import { createContext, useContext } from 'react';

var isInternalLink = function isInternalLink(href) {
  return href.startsWith('/');
};

export var EmbedModeContext = /*#__PURE__*/createContext({
  isEmbedded: false,
  host: undefined,
  platform: undefined,
  jwt: undefined,
  suppressErrors: false,
  useShadowDom: false
});
export var useEmbedMode = function useEmbedMode() {
  var _useContext = useContext(EmbedModeContext),
      isEmbedded = _useContext.isEmbedded,
      host = _useContext.host,
      platform = _useContext.platform,
      jwt = _useContext.jwt,
      suppressErrors = _useContext.suppressErrors,
      useShadowDom = _useContext.useShadowDom;

  return {
    isEmbedded: isEmbedded,
    host: host,
    platform: platform,
    jwt: jwt,
    suppressErrors: suppressErrors,
    useShadowDom: useShadowDom,
    convertToEmbedPath: function convertToEmbedPath(to) {
      return isEmbedded && host && to && isInternalLink(to) ? "https://".concat(host).concat(to) : to;
    }
  };
};